import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {BookmakerData} from "../../@types/response";

export const getBookmakers = (state: ReducerFromState<CommonReducer>): BookmakerData => state.common.bookmakers;